import script from "./AppShell.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppShell.vue?vue&type=script&setup=true&lang=ts"

import "./AppShell.vue?vue&type=style&index=0&id=73c47394&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73c47394"]])

export default __exports__